import { render, staticRenderFns } from "./PersonalDataResultMessage.vue?vue&type=template&id=19ece620&scoped=true&"
import script from "./PersonalDataResultMessage.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataResultMessage.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDataResultMessage.vue?vue&type=style&index=0&id=19ece620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ece620",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VSpacer})
